var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('menu-context-menu',{staticStyle:{"height":"100%","width":"100%"},attrs:{"position":_vm.saveMouseEvent}},[_vm._t("default"),_c('template',{slot:"contextmenu"},[_c('ModuleOutlet',{attrs:{"type":"contextMenu"}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }